module.exports = __webpack_public_path__ + "static/potato-745bdd4252c6f3e7353991adb1d2b996.png";